
// AuditFilters.jsx — filter bar for AuditTable
import React from "react";

export default function AuditFilters({
  country,
  setCountry,
  year,
  setYear,
  onAddFinding,
  onImport,
  user,
}) {
  const isAdmin =
    user?.user_type?.toLowerCase() === "admin" ||
    Number(user?.is_admin) === 1;

  const userCountry = String(user?.location || "")
    .trim()
    .toUpperCase();

  const countries = [
    { code: "FR", name: "France" },
    { code: "DE", name: "Germany" },
    { code: "BE", name: "Belgium" },
    { code: "CH", name: "Switzerland" },
    { code: "US", name: "United States" },
    { code: "ES", name: "Spain" },
    { code: "IE", name: "Ireland & UK" },
    { code: "GR", name: "Greece" },
    { code: "IT", name: "Italy" },
  ];

  const availableCountries = isAdmin
    ? countries
    : countries.filter((c) => c.code === userCountry);

  return (
    <div className="audit-filterbar">
      <h3 className="audit-title">
        Audit Findings – {country} ({year})
      </h3>

      <div className="audit-filterbar-right">
        <select
          className="form-select audit-select"
          value={country}
          onChange={(e) => setCountry(e.target.value)}
          disabled={!isAdmin}
        >
          {availableCountries.map((c) => (
            <option key={c.code} value={c.code}>
              {c.name}
            </option>
          ))}
        </select>

        <select
          className="form-select audit-select"
          value={year}
          onChange={(e) => setYear(e.target.value)}
        >
          {[2023, 2024, 2025, 2026].map((y) => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </select>

        <button
          type="button"
          className="audit-add-btn"
          onClick={onAddFinding}
        >
          Add Finding
        </button>

        <button
          type="button"
          className="audit-add-btn"
          onClick={isAdmin ? onImport : undefined}
          disabled={!isAdmin}
          title={isAdmin ? "Import CSV" : "Admins only"}
          style={
            !isAdmin
              ? { opacity: 0.6, cursor: "not-allowed" }
              : {}
          }
        >
          Import CSV
        </button>
      </div>
    </div>
  );
}